import { EvtSectionHeader } from "components/header";
import Icon from "components/icon";
import { ReviewerPendingReviewHoursCard } from "components/timesheet/dashboard/reviewer-overview/pending-review-hours-card";
import { Link } from "react-router-dom";
import React from "react";
import { UP_RIGHT } from "icons";

const ReviewerSection = () => {
    return (
        <section className="mt-3.5">
            <EvtSectionHeader
                title={
                    <Link
                        className="flex items-center"
                        to={"/timesheet/reviews/calendar"}
                    >
                        Review Overview
                        <Icon icon={UP_RIGHT} className="size-5  ml-1" />
                    </Link>
                }
            />
            <div className=" lg:flex gap-y-4 lg:gap-y-6  items-center lg:flex-row grid sm:grid-cols-2 grid-cols-1 md:px-6 px-4 mt-4.5 ">
                <ReviewerPendingReviewHoursCard />
            </div>
        </section>
    );
};

export default ReviewerSection;
